import React from "react";

export default function Footer(){
    return (
        <div className="Footer">
          <p> This project was coded by <a href="https://www.instagram.com/jane_muravshchyk/" target="_blank" rel="noreferrer">Jane Mur</a> and is <a href="https://github.com/JenyaMur/dictionary-app" target="_blank" rel="noreferrer">open-sourced on GitHub </a> </p>
        </div>
    );
    
}